export enum PageListModuleDropdownAction {
  SetAsDefaultModule = 'setAsDefaultModule'
}
